// extracted by mini-css-extract-plugin
module.exports = {"asider":"sidebar_asider__ZtzOQ"};